import {CommonRootState} from '../reducers';
import {createSelector} from '@reduxjs/toolkit';
import {ILoaderState} from '../reducers/loaderSlice';

export const selectLoadingSlice = (state: CommonRootState) => state.loader;

export const isLoadingSelector = createSelector([selectLoadingSlice], (state: ILoaderState) => state.isLoading);
